import React, { useEffect, useState } from 'react'
import { Modal, Input, Select, Button } from 'antd';
import { retrieveData, storeData, triggerNotification, useGetApiRequests } from '../../../common/CommonExport';
import { CommonError, OrganisationIdState, ApiSuccessResponse } from '../../../common/types';
import { SalaryComponentState, AddComponentProps, OptionType } from './RegularEmployeeTypes';
import FloatLabel from '../../../components/FloatLabel';
import { useSelector, useDispatch } from 'react-redux';
import { salaryUpdate } from '../../../redux/salary-master/salaryAction';
const AddComponentModal = (props: AddComponentProps) => {

  const { open, editParticulars, handleClose, groupName } = props;
  const saveSalaryMaster = useGetApiRequests('saveSalaryMaster', 'PUT');
  const addSalaryMaster = useGetApiRequests('saveSalaryMaster', 'POST');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState<string>('percent');
  const [selectedPeriod, setSelectedPeriod] = useState<string>('monthly');
  const [isYear, setIsYear] = useState<boolean>(false);
  const orgId = useSelector((state: OrganisationIdState) => state?.organisationId?.id);
  const dispatch = useDispatch();
  const [showError, setShowError] = useState<boolean>(false)
  const [isEdit, setIsEdit] = useState()
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState<SalaryComponentState>({
    "name": '',
    "code": '',
    "groupName": '',
    "sectionName": '',
    "salaryComponentId": '',
    "organisation": {
      "organisationId": orgId
    },
    "percent": '',
  })

  useEffect(() => {


    setIsEdit(retrieveData("iSnewItem", true))


    setModalOpen(open);
    let iSnewItem = retrieveData("iSnewItem", true)
    if (!iSnewItem) {
      let particularType = editParticulars.type == " %" ? " %" : "Amount";
      setSelectedValue(particularType)
      setSelectedPeriod(editParticulars.sectionName)
      setValues({
        "name": editParticulars.name,
        "groupName": editParticulars.groupName,
        "sectionName": editParticulars.sectionName,
        "salaryComponentId": editParticulars.salaryComponentId,
        "organisation": {
          "organisationId": orgId
        },
        "percent": editParticulars.percent,
        "amount": editParticulars.amount,
        "type": editParticulars.type,
        "code": editParticulars.code
      })
    }
    else {
      setSelectedValue("")

    }
    return (() => {
      setModalOpen(false);
      storeData("iSnewItem", false, true)
    })
  }, [props.open])

  const handelEDit = () => {
    setShowError(true)
    const payload = values;
    const pathParam = {
      param: payload.salaryComponentId
    }
    const query = {
      query: ""
    }
    let iSnewItem = retrieveData("iSnewItem", true)
    if (iSnewItem && values.name != "") {
      setLoading(true)
      delete payload.salaryComponentId
      delete payload.type

      if ((orgId === 563 || orgId === 564) && groupName === undefined) {
        payload.groupName = "Employee Contribution"
      }
      else {
        payload.groupName = groupName || ""
      }
      addSalaryMaster(payload, {}, query)
        .then((res: unknown) => {
          setLoading(false)
          const response = res as ApiSuccessResponse;
          triggerNotification('success', '', response?.data?.status?.message || '', 'topRight');
          dispatch(salaryUpdate(true))
          setModalOpen(false)
          handleClose()
        })
        .catch((err: unknown) => {
          setLoading(false)
          const error = err as CommonError;
          triggerNotification('error', '', error?.message || '', 'topRight');
        })
    }
    else if (!iSnewItem && values.name != "") {
      setLoading(true)
      payload.groupName = editParticulars.groupName
      saveSalaryMaster(payload, {}, pathParam)
        .then((res: unknown) => {
          setLoading(false)
          const response = res as ApiSuccessResponse;
          triggerNotification('success', '', response?.data?.status?.message || '', 'topRight');
          dispatch(salaryUpdate(true))
          setModalOpen(false)
          handleClose()
        })
        .catch((err: unknown) => {
          setLoading(false)
          const error = err as CommonError;
          triggerNotification('error', '', error?.message || '', 'topRight');
        })
    }
  }
  const handleChange = (value: string | number, field: string) => {
    if (field === 'name') {
      setValues({ ...values, name: String(value) });
    } else if (field === 'percents') {
      if (selectedValue === "percent") {
        setValues({ ...values, percent: Number(value), amount: 0, sectionName: "yearly" })
      }
      else {
        setValues({ ...values, amount: Number(value), percent: 0, sectionName: "monthly" })
      }
    }
    else if (field === 'type') {
      const typeValue = value as string;
      setSelectedValue(typeValue)
      if (typeValue === "percent") {
        setSelectedValue(" %")
        setIsYear(false)
        setValues({ ...values, amount: 0, percent: 0, sectionName: "yearly" })
      }
      else {
        setIsYear(true)
        setValues({ ...values, amount: 0, percent: 0, sectionName: "monthly" })
      }
    }
    else if (field === "period") {
      const periodValue = value as string;
      setSelectedPeriod(periodValue)
      setValues({ ...values, sectionName: periodValue })
    }
    else {
      const groupValue = value as string;
      setSelectedPeriod(groupValue)
      setValues({ ...values, groupName: groupValue })
    }
  }
  const handelCloseModal = () => {
    setSelectedValue("")
    setValues({
      "name": "",
      "groupName": "",
      "sectionName": "",
      "salaryComponentId": "",
      "organisation": {
        "organisationId": orgId
      },
      "percent": "",
      "amount": "",
      "type": "",
      "code": ""
    })
    setModalOpen(false)
    handleClose()
  }

  const amount = [{ value: 'percent', label: '%' },
  { value: 'amount', label: 'Amount' }]
  const period = [{ value: 'yearly', label: 'Yearly' },
  { value: 'monthly', label: 'Monthly' }]
  return (
    <Modal title={isEdit ? "Add salary particular " : 'Edit salary particular'} className='salaryStructure-modal' centered open={modalOpen} footer={null} onCancel={handelCloseModal} maskClosable={!loading} keyboard={!loading} closable={!loading}>
      <div className="salary-date ">
        <div className='grid grid-cols-2 gap-10'>
          <div className='form-item basicForm-fields mb-6' >
            <FloatLabel label='Name *' name='ctc' value={values.name}>
              <Input
                type="text"
                className='float-control'
                name="name"
                value={values.name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e.target.value, 'name')}
              />
              {showError && values.name === "" && <span className='text-xs text-red-400 '>Enter the particular name</span>}

            </FloatLabel>
          </div>
          <div className='form-item edit-salary-details  flex'>
            <div className='form-item basicForm-fields mb-6' >
              <FloatLabel name='amt' label={selectedValue?.toLowerCase() === "amount"
                ? "Enter Amount"
                : selectedValue?.toLowerCase() === " %"
                  ? "Enter Percent"
                  : "Select Accrual type"} value={values.percent ? (Number(values.percent) + 1) : (Number(values.amount || 0) + 1)}>
                <Input
                  type="number"
                  className='float-control'
                  name="currentctc" value={Number(values.percent) !== 0 ? values.percent : (values.amount || 0)}
                  onChange={(e) => {
                    const inputValue = parseInt(e.target.value, 10);
                    const limitedValue: number = Number(values.percent) !== 0 ? Math.min(inputValue, 100) : Math.min(inputValue, 99999999);
                    handleChange(limitedValue, 'percents');
                  }}
                />
              </FloatLabel>
            </div>
            <div className="form-item relative bottom-[0.5px] ">
              <div>
                <Select
                  placeholder="Type"
                  options={amount}
                  style={{ height: '56px' }}
                  value={selectedValue}
                  onChange={(value: string) => handleChange(value, "type")} >
                  {amount.map((option: OptionType) => (
                    <Select.Option key={option.value} value={String(option.value)}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
        </div>
        {(selectedValue == "Amount" || isYear) &&
          <div className="form-item edit-salary-details ">
            <Select
              placeholder="Select your rating"
              options={period}
              value={selectedPeriod}
              onChange={(value: string) => handleChange(value, "period")} >
              {period.map((option: OptionType) => (
                <Select.Option key={option.value} value={String(option.value)}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </div>
        }
      </div>
      <div className='flex justify-end mr-5 salary_add-btn'>
        <Button loading={loading} className='addButton ' onClick={handelEDit}>
          Submit
        </Button>
      </div>
    </Modal>
  )
}

export default AddComponentModal